<script lang="ts">
	import { PUBLIC_LOL_CDN_URL } from '$env/static/public';
</script>

<div
	class="border-darkTertiary bg-darkSecondary hover:border-darkQuaternary group relative h-80 w-full overflow-hidden rounded-lg border p-6 shadow-sm transition-all"
	role="figure"
>
	<div class="card-spotlight -top-32 z-0 aspect-square h-80" />
	<div class="grid h-full w-full grid-rows-5 items-center justify-center gap-4">
		<div class="relative row-span-3 flex h-full w-full flex-row items-center justify-center">
			<img
				loading="lazy"
				src={`${PUBLIC_LOL_CDN_URL}/champion/Darius.png?fm=webp`}
				class="h-16 w-16 rounded-full transition-all duration-500 group-hover:h-8 group-hover:w-8"
				alt="Darius"
			/>
			<img
				loading="lazy"
				src={`${PUBLIC_LOL_CDN_URL}/champion/Blitzcrank.png?fm=webp`}
				class="absolute left-24 top-2 h-6 w-6 rounded-full transition-all duration-1000 group-hover:h-12 group-hover:w-12"
				alt="Blitzcrank"
			/>
			<img
				loading="lazy"
				src={`${PUBLIC_LOL_CDN_URL}/champion/Bard.png?fm=webp`}
				class="absolute bottom-4 left-12 h-8 w-8 rounded-full transition-all duration-300 group-hover:left-20 group-hover:h-12 group-hover:w-12"
				alt="Bard"
			/>
			<img
				loading="lazy"
				src={`${PUBLIC_LOL_CDN_URL}/champion/Maokai.png?fm=webp`}
				class="absolute bottom-12 right-12 h-10 w-10 rounded-full transition-all duration-700 group-hover:right-20 group-hover:h-12 group-hover:w-12"
				alt="Maokai"
			/>
		</div>
		<div
			class="row-span-2 mx-auto flex h-full w-full max-w-sm flex-col items-center justify-center gap-2 text-center"
		>
			<h3 class="text-xl font-normal">Counter Picks</h3>
			<p class="text-lightTertiary">
				Want to know how to counter a champion? Ask Meeko for recommended counter picks.
			</p>
		</div>
	</div>
</div>
